import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
})
export class ConfirmationModalComponent {
  @Input() public title: string;
  @Input() public message: string;
  @Input() public okButtonText: string = 'Confirm';
  @Input() public cancelButtonText: string = 'Close';

  constructor(private _modalController: ModalController) {}

  public close(result: boolean): void {
    this._modalController.dismiss(result);
  }
}
